import VueCharts from "vue-chartjs";
import { HorizontalBar, Line } from "vue-chartjs";
import * as Annotation from "chartjs-plugin-annotation";
import ChartDataLabels from 'chartjs-plugin-datalabels';

export default {
  extends: HorizontalBar,
  props: {
    labels: { type: Array },
    datasets: { type: Array },
  },

  mounted() {
    this.renderChart(
      {
        labels: this.labels,
        datasets: this.datasets
      },
      {
        title: {
          display: false,
          text: "",
        },
        scales: {
          yAxes: [
            {

              ticks: {
                beginAtZero: true,
                stepSize: 1,
                min: 0,
                autoSkip: false,
              },
              scaleLabel: {
                display: true,
                labelString: "บุคลากร",
              },
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "คะแนน",
              },

              stacked: false,
              ticks: {
                stepSize: 1,
                min: 0,
                max: 25,
                autoSkip: false,
                beginAtZero: true,

              }
            },
          ],
        },

        plugins: {
          datalabels: {
            color: "#fff",
            rotation: 0,
            anchor: "center",
            offset: "bottom",
            clamp: true,
            font: {
              size: 11.5,
            },
            formatter: (value) => {
              return value;
            }
          },
        },

        legend: {
          display: false,

        },
        responsive: true,
        maintainAspectRatio: false,
      }
    );
  },
};
